<template>
  <Accordion :error="$v.supplierInformation.supplier.$error" id="supplier" title="FORNECEDOR">
    <b-row class="row-padding">
      <b-col md="5">
        <SelectWithSearch
          label="Pesquisar Fornecedor"
          placeholder="Pesquise o Nome/CPF/CNPJ"
          ref="searchSupplier"
          v-model="supplierInformation.supplier"
          :error="$v.supplierInformation.supplier.$error"
          :options="supplierCollection"
          :change="changeSupplierSelected"
          :search="searchSupplier"
        >
          <template slot="options" slot-scope="props">
            <div class="selected" style="text-transform: uppercase">
              {{ props.data.name }}
              <br />
              CPF/CNPJ {{ props.data.identificationFormatted }}
            </div>
          </template>
          <template slot="no-options"> Nenhum fornecedor encontrado </template>
          <template slot="selected" slot-scope="props">
            <div class="selected" style="text-transform: uppercase">
              {{ props.data.name }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
      <b-col md="3">
        <Label>CNPJ:</Label>
        <b-form-input :value="supplierInformation.supplier.identificationFormatted" disabled>
        </b-form-input>
      </b-col>
      <b-col md="2">
        <Label>IE:</Label>
        <b-form-input disabled v-model="supplierInformation.supplier.stateCode" />
      </b-col>
      <b-col md="2">
        <Label>CEP:</Label>
        <b-form-input
          :value="formatCep(supplierInformation.supplier.address.zipCode.zipCode)"
          disabled
        >
        </b-form-input>
      </b-col>
    </b-row>
    <div>
      <div>
        <b-row class="row-padding pt-0">
          <b-col md="5">
            <Label>Endereço:</Label>
            <b-form-input v-model="completeAddress" disabled>
            </b-form-input>
          </b-col>
          <b-col md="3">
            <Label>Bairro/Distrito:</Label>
            <b-form-input disabled v-model="supplierInformation.supplier.address.neighbourhood" />
          </b-col>
          <b-col md="3">
            <Label>Município:</Label>
            <b-form-input v-model="supplierInformation.supplier.address.zipCode.city.name" disabled>
            </b-form-input>
          </b-col>
          <b-col md="1">
            <Label>UF:</Label>
            <b-form-input
              disabled
              v-model="supplierInformation.supplier.address.zipCode.city.state.acronym"
            >
            </b-form-input>
          </b-col>
        </b-row>
      </div>

      <b-row class="row-padding pt-0">
        <b-col md="3">
          <Label>Fone Comercial:</Label>
          <b-form-input disabled v-model="phoneFormatted">
          </b-form-input>
        </b-col>
      </b-row>
    </div>
  </Accordion>
</template>

<script>
import { Accordion } from '@/components';
import { mapState, mapActions, mapGetters } from 'vuex';
import { formatPhone } from '@/core/helpers/formater/phone';
import { SelectWithSearch, Label } from '@/components/Form';
import { required } from 'vuelidate/lib/validators';
import FormatMixin from '../../../../../Application/mixins/FormatMixin';

export default {
  name: 'Supplier',
  mixins: [FormatMixin],
  components: {
    Accordion,
    SelectWithSearch,
    Label,
  },
  validations: {
    supplierInformation: {
      supplier: {
        id: {
          required,
        },
      },
    },
  },
  async mounted() {
    await this.setSupplierCollection();
  },
  computed: {
    ...mapState('purchase', [
      'supplierInformation',
      'taxInformation',
    ]),
    ...mapState('person', ['supplierCollection']),
    ...mapGetters('purchase', [
      'getDefaultAddressState',
      'getDefaultPhoneState',
      'getDefaultSupplierState',
    ]),
    completeAddress() {
      const { street } = this.supplierInformation.supplier.address;
      let { number, complement } = this.supplierInformation.supplier.address;
      if (number) number = `, ${number}`;
      if (complement) complement = ` - ${complement}`;

      return `${street ?? ''}${number ?? ''}${complement ?? ''}`;
    },
    phoneFormatted() {
      if (!this.supplierInformation.supplier.phone) return '';
      const { areaCode, number } = this.supplierInformation.supplier.phone;
      const phone = `${areaCode ?? ''}${number ?? ''}`;

      return formatPhone(phone);
    },
  },
  methods: {
    ...mapActions('person', ['setSupplierCollection']),
    ...mapActions('purchase', [
      'setSupplier',
      'setMatchedCfopForPurchaseTaxInformation',
    ]),
    async searchSupplier(search = null) {
      if (search) {
        await this.setSupplierCollection(search);
      }
    },
    changeSupplierSelected(selectedSupplier) {
      if (selectedSupplier) {
        const supplier = {
          ...selectedSupplier,
          address:
            selectedSupplier?.addressCollection[0] ??
            this.getDefaultAddressState,
          phone:
           selectedSupplier?.phoneCollection[0] ?? this.getDefaultPhoneState,
        };

        if (!supplier.address?.zipCode) {
          supplier.address.zipCode = {
            city: { name: '', state: { acronym: '' } },
          };
        }

        this.buildTaxInformationCfop(selectedSupplier);
        this.setSupplier(supplier);

        this.$root.$emit('bv::toggle::collapse', 'products');

        return;
      }

      this.setSupplier(this.getDefaultSupplierState);
    },
    buildTaxInformationCfop(selectedSupplier) {
      if (!this.taxInformation.natureza.cfop.id) return;

      this.setMatchedCfopForPurchaseTaxInformation({
        supplierId: selectedSupplier.id,
        cfopIdPurchaseHeader: this.taxInformation.natureza.cfop.id,
      });
    },
  },
  watch: {
    supplierInformation: {
      handler() {},
      deep: true,
    },
  },
};
</script>
